import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
  static targets = [
    "filterSegmentsButton",
    "selectSegmentsButton",
    "saveOptimizedProfileButton",
    "departmentSelect",
  ];

  static classes = ["hidden"];

  static values = {
    saveOptimizedProfileSubmitButtonKey: String,
  };

  filterSegmentsButtonTargetConnected(target) {
    target.classList.add(this.hiddenClass);
  }

  selectSegmentsButtonTargetConnected(target) {
    target.classList.add(this.hiddenClass);
  }

  departmentSelectTargetConnected(target) {
    // eslint-disable-next-line no-param-reassign
    target.querySelector("option:first-child").dataset.placeholder = "true";

    // Prevents the select from being translated by Google Translate.
    // On this page, when the select gets translated, the SlimSelect library
    // will change the DOM for it which will trigger a new translation by
    // Google Translate, which will change the DOM again, and so on.
    // Checking the value of the select in the submit method is not enough to
    // get the translation to work...
    target.classList.add("notranslate");

    this.departmentSlimSelect = new SlimSelect({
      select: target,
      settings: { allowDeselect: true, showSearch: true },
    });
  }

  departmentSelectTargetDisconnected() {
    this.departmentSlimSelect.destroy();
  }

  filterSegments(event) {
    const {
      currentTarget: { value },
    } = event;
    if (value === "") {
      this.filterSegmentsButtonTarget.click();
    }
  }

  selectSegment() {
    this.selectSegmentsButtonTarget.click();
  }

  saveOptimizedProfile(event) {
    event.preventDefault();
    this.saveOptimizedProfileButtonTarget.click();
  }

  /**
   * This method filters the submit events from the form validation and
   * dispatches the main-submit-end event that then can be listened to by other
   * controllers interested in the form submission such as the `LoaderOverlay`
   * controller.
   *
   * @param {Event} event
   */
  submitEnd(event) {
    const { detail: { success, formSubmission = {} } = {} } = event;
    const { submitter = {} } = formSubmission;
    const { name: submitterName, value: submitterValue } = submitter;

    if (
      success &&
      submitterName === "_submit_type" &&
      submitterValue === this.saveOptimizedProfileSubmitButtonKeyValue
    ) {
      this.dispatch("form-submitted-with-success", event);
    }
  }
}
